import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import AvatarEditor from 'react-avatar-editor';
import events from './events';

class ImageCropper extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      scale: 1.0,
      isSaving: false,
      uploadError: null,
    };
  }

  handleClickSaveImage = evt => {
    const { screen } = this.props;
    const _this = this;

    if (this.avatarEditorElement) {
      // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
      // drawn on another canvas, or added to the DOM.
      const canvas = this.avatarEditorElement.getImage();
      if (!canvas.toBlob) {
        this.setState({
          uploadError: new Error(
            'Please try a browser that supports creating files from canvas.'
          ),
        });
        return;
      }
      events.newImageSaved({ location: screen });
      canvas.toBlob(imageBlob => {
        _this.props.onImageCrop(imageBlob);
      });
    }
  };

  handleChangeScale = evt => {
    this.setState({
      scale: parseFloat(evt.target.value),
    });
  };

  render() {
    const { imageFile, onCancel } = this.props;

    const { scale, isSaving } = this.state;
    return (
      <React.Fragment>
        <AvatarEditor
          image={this.props.imageFile}
          width={400}
          height={400}
          disableDrop
          color={[255, 255, 255, 0.2]} // RGBA
          ref={node => {
            this.avatarEditorElement = node;
          }}
          scale={this.state.scale}
        />
        <label>
          <h6>Zoom</h6>
          <input
            type="range"
            onChange={this.handleChangeScale}
            min={1}
            step={0.1}
            max={4}
            value={scale}
          />
        </label>
        <p>
          <Button
            data-cy="saveImageCrop"
            bsStyle="primary"
            disabled={isSaving}
            onClick={this.handleClickSaveImage}
          >
            Save
          </Button>
          <Button bsStyle="link" onClick={onCancel}>
            Cancel
          </Button>
        </p>
      </React.Fragment>
    );
  }
}

export default ImageCropper;
